module.exports = __webpack_public_path__ + "media/images/sindma/pba-logo-a9cc2f305192b982f3ae8654691da738.png";